export default function displayPropertyUse(results) {
    let s = `<h3>Property Use</h3>
   `
    if (results)
        {
            s+= `<table class="summaryTable  table-responsive">    
            <thead>
                <th>Use Code</th><th>Description</th>
            </thead>`;

            for (let i = 0, il = results.length; i < il; i++) {
                s+=`<tr>
                        <td>${results[i].use_code}</td><td> ${results[i].use_code_desc}</td>
                    </tr>`
            }
            s += "</table>";

        }
        else {
            s+= `<p>No property use data to display.</p>`
        }
    return s; 
}